import "bootstrap-icons/font/bootstrap-icons.css";
import "devextreme/dist/css/dx.material.blue.light.compact.css";
import "./assets/css/tailwind.css";
import "./assets/css/style.css";
import "./assets/css/authStyle.css";
import "./assets/scss/main.scss";
import "./assets/css/customGrids.css";
import "./assets/css/multiselect.css";
import "./assets/fonts/Lato/LatoFonts.css";
import "primevue/resources/themes/lara-light-teal/theme.css";
import "primeicons/primeicons.css";
import "vue-multiselect/dist/vue-multiselect.css";
import "@vuepic/vue-datepicker/dist/main.css";
import "vue-toastification/dist/index.css";
import "vue-skeletor/dist/vue-skeletor.css";
import "./assets/css/primevue-custom.css";
import "vue-tel-input/vue-tel-input.css";

// Apply saved theme before Vue mounts to prevent flash of unstyled content.
// When no explicit choice is stored, mirror useTheme.js's own "system" logic
// (OS/browser dark-mode preference) instead of defaulting to light — since
// import hoisting means this runs after useTheme.js's own module-level
// applyTheme() call, a naive "light" fallback here would silently clobber a
// correct system-dark result back to light on every load.
const storedTheme = localStorage.getItem('theme')
const prefersDark = typeof window.matchMedia === 'function'
  && window.matchMedia('(prefers-color-scheme: dark)').matches
const savedTheme = storedTheme || (prefersDark ? 'dark' : 'light')
document.documentElement.setAttribute('data-theme', savedTheme)

import { createApp } from "vue";
import { startKeepAlive } from "@/utils/sessionKeepAlive";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import VueTelInput from "vue-tel-input";
import { Skeletor } from "vue-skeletor";

const app = createApp(App);

import PrimeVue from "primevue/config";
import Dialog from "primevue/dialog";
import MultiSelect from "primevue/multiselect";
import Dropdown from "primevue/dropdown";
import FloatLabel from "primevue/floatlabel";
import Textarea from "primevue/textarea";
import DModal from "@/components/shared/DModal.vue";
import DInput from "@/components/shared/DInput.vue";
import InputText from "primevue/inputtext";
import Multiselect from "vue-multiselect";
import VueDatePicker from "@vuepic/vue-datepicker";

import Toast from "vue-toastification";

const user = JSON.parse(localStorage.getItem("userDetails"));

const globalOptions = {
  mode: "auto",
  inputOptions: {
    placeholder: "Phone Number (Optional)",
  },
  customValidate: /^\d*$/,
  dropdownOptions: {
    showSearchBox: true,
  },
  validCharactersOnly: true,
};

app.provide("global_user_name", [user?.first_name, user?.last_name].filter(Boolean).join(' '));

app.component("DModal", DModal);
app.component("DInput", DInput);
app.component("PInput", InputText);
app.component("PDialog", Dialog);

app.component("VMultiselect", Multiselect);
app.component("VueDatePicker", VueDatePicker);
app.component(Skeletor.name, Skeletor);

app.use(Toast);
app.use(PrimeVue);
app.use(VueTelInput, globalOptions);
app.component("FloatLabel", FloatLabel);
app.component("PTextarea", Textarea);
app.component("PMultiSelect", MultiSelect);
app.component("PDropdown", Dropdown);

app.use(createPinia());
app.use(router);
app.mount("#app");

// Resume keep-alive for already-authenticated sessions (hard reloads, new tabs).
if (localStorage.getItem("user")) {
  startKeepAlive();
}
